import { render } from "./ButtonCopyClipboard.vue?vue&type=template&id=24d9e509&scoped=true&ts=true"
import script from "./ButtonCopyClipboard.vue?vue&type=script&lang=ts"
export * from "./ButtonCopyClipboard.vue?vue&type=script&lang=ts"

import "./ButtonCopyClipboard.vue?vue&type=style&index=0&id=24d9e509&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d9e509"]])

export default __exports__